import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
import { LoginService } from '../../../../../../services/login/login.service';
import { EmpresaService } from '../../../../../../services/Empresa/Empresa.service';
import { autocompleteGroup } from '../models/Search';
import { Categoria } from '../models/Categoria';

@Injectable({
  providedIn: 'root'
})
export class BusquedaProductosService {
  private url = environment.apiUrl;
  empresaId: number;

  constructor(
    private loginService: LoginService,
    private http: HttpClient,
    private empresaService: EmpresaService
  ) {
    this.empresaId = empresaService.getEmpresaId();
  }

  public search = (
    textoBusqueda: string,
    orden: string,
    pagina: number,
    marca: number | string,
    grupo: number | string,
    existencia: string,
    sugerido?: boolean
  ) => {
    const infoCliente = this.loginService.getDataClientePedido();
    console.log(infoCliente)
    const datosQuery = {
      empresaID: this.empresaId,
      almacen: infoCliente.almacenPre,
      almacenID: infoCliente.almacenPre,
      clientID: infoCliente.client_number,
      searchText: textoBusqueda,
      clasificacion: orden,
      disponible: 1,
      page: pagina,
      perpage: 48,
      showprice: true,
      marca,
      grupo,
      existencia,
      sugerido,
      option: 'search-sugerido'
    }
    console.log("datos busqueda:", datosQuery)
    return this.http.post<any>(this.url + 'Servicios-web/Search/search.php', datosQuery)
      .pipe(map((respuesta) => respuesta))
  }

  public searchEspecifica = (
    page: number,
    orderBy: string,
    categoryID?: string | number,
    grupo?: string | number,
    marca?: string | number,
    existencias?: number,
    namesoluciones?: string
  ) => {
    const cliente = this.loginService.getDataClientePedido();
    const dataquery = {
      empresa: this.empresaId,
      empresaID: this.empresaId,
      almacen: cliente.almacenPre,
      almacenID: cliente.almacenPre,
      clientID: cliente.client_number,
      departamento: categoryID,
      grupo,
      marca,
      clasificacion: orderBy,
      disponible: 1,
      page,
      perpage: 48,
      showprice: true,
      existencias,
      namesoluciones,
      option: 'facets-fitro',
    };
    return this.http
      .post<any>(this.url + 'Servicios-web/Search/search.php', dataquery)
      .pipe(map((response) => response));
  };

  public getCategoria = (): Observable<Categoria> => {
    const data = {
      option: 'getMenuCategorias',
      empresaID: environment.empresaId,
    };

    return this.http.post<Categoria>(this.url + 'Servicios-web/Menu/GetMenuHeader.php', data).pipe(map((data) => data));
  }

  public getMarcas = (): Observable<any> => {
    const data = {
      option: 'getMenuMarcas',
      empresaID: 1,
    };
    return this.http.post<any>(this.url + 'Servicios-web/Menu/GetMenuHeader.php', data).pipe(map(response => response));
  }

  //   FUNCION PARA BUSCAR CATEGORIAS
  searchAutocomplete = (dato: any): Observable<autocompleteGroup> => {
    const dataquery = {
      option: 'ListaGrupos',
      dato,
      empresaID: this.empresaId,
    };
    return this.http.post<autocompleteGroup>(this.url + 'Servicios-web/Search/grupos.php', dataquery).pipe(map(resp => {
      return resp;
    }));
  }
}